// extracted by mini-css-extract-plugin
module.exports = {"list":"List_list__3wU8o","title":"List_title__W8DuS","nav":"List_nav__3HHdT","link":"List_link__14afI","active":"List_active__1509t","wrapper":"List_wrapper__N9KJS"};